import { render, staticRenderFns } from "./ModalLoad.vue?vue&type=template&id=35dd43cc&scoped=true&"
import script from "./ModalLoad.vue?vue&type=script&lang=js&"
export * from "./ModalLoad.vue?vue&type=script&lang=js&"
import style0 from "./ModalLoad.vue?vue&type=style&index=0&id=35dd43cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd43cc",
  null
  
)

export default component.exports